import { ErrorHandler, Injectable } from '@angular/core';
import { config, notify } from 'atatus-spa'
import { environment } from '../../environments/environment';
import { LocalStorageService } from '../services/local-storage.service';
import { HttpErrorResponse } from '@angular/common/http';
import { blank, data_get, fallback, str_contains, str_lower, transform } from '../shared/utils/common';
import { ClientStoreService } from '../services/client-store.service';

config(environment.atatus_config, {
  hashRoutes: true,
}).install();

@Injectable({
  providedIn: 'root',
})
export class AtatusErrorHandler implements ErrorHandler {
  constructor(
    private readonly _store: LocalStorageService,
    private readonly _clients: ClientStoreService,
  ) {}

  static localStorageService: LocalStorageService;

  handleError(err: any): void {
    if (str_contains(data_get(err, 'message'), {
      pattern: 'removeChild',
    })) {
      return;
    }

    console.error('An error occurred. Please see below and contact support...');
    console.error(err);

    /// statuses that shouldn't be reported
    /// 401 - token might be expired or user is not authenticated
    /// 403 - user attempts to access something forbidden
    /// 404 - a record was not found
    /// 422 - a validation error occurred
    if (data_get(err, 'status') === 401
      || data_get(err, 'status') === 403
      || data_get(err, 'status') === 404
      || data_get(err, 'status') === 422
    ) {
      return;
    }

    /// ignore report when we don't have valid error
    if (blank(data_get(err, 'message'))
      || str_contains(str_lower(data_get(err, 'message')), {
          pattern: 'loading chunk',
        })
    ) {
      return;
    }

    this._report(err);
  }

  private _report(err: any, opts: {
    data?: Record<string, any>,
  } = {}): void {
    if (blank(atatus)) {
      return;
    }

    const name = fallback(this._store.getItem('user_name'), {
      to: () => 'No Name',
    });

    const email = fallback(this._store.getItem('user_email'), {
      to: () => 'No Email',
    });

    // notify atatus
    notify(err.originalError || err, {
      user_name: name,
      user_email: email,
      client_details: transform(this._clients.getActiveClient(), {
        transformer: (client) => ({
          id: data_get(client, 'client_id'),
          name: data_get(client, 'name'),
          level: data_get(client, 'level'),
        }),
      }),
      ... (err instanceof HttpErrorResponse && {
        response_status: err.status,
        response_body: err.error,
        request_url: err.url,
        request_type: err.type
      }),
    });
  }
}